export const getPostCount = (state) => state.postCount;
